// extracted by mini-css-extract-plugin
module.exports = {"btn":"_2w7cWJze1Njgtd6bV3iyEe","icon":"_3POIXH5BOiFwQaVhBdPyv1"};